import PriceBookListCard from "@legacy/pricebook/components/PriceBookItemListCard"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"

import replaceSlugs from "@utils/replaceSlugs"

import { CardList, Table, ViewBar } from "@organisms"

import { CREATE_ROUTE_MAP, PRICEBOOK_TYPE_NAME_MAP } from "@pages/Pricebook/PricebookList/PricebookList"
import {
    DiscountsTabs,
    MiscellaneousTabs,
    PartsAndMaterialsTabs,
    ServicesTabs,
    TaxRatesTabs,
} from "@pages/Pricebook/PricebookList/views/PricebookTableView/PricebookTableViewTabs"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import {
    PRICEBOOK_LIST_CONTROLS_ACTIVE_TAB,
    PRICEBOOK_LIST_CONTROLS_KEYWORD_SEARCH,
    PRICEBOOK_LIST_CONTROLS_ORDERING,
    PRICEBOOK_LIST_CONTROLS_PHASE,
} from "@constants/storage"

import { PricebookCardViewProps } from "./PricebookCardView.types"

export default function PricebookCardView(props: PricebookCardViewProps) {
    const { pricebookTypeName } = props
    const pricebookType = PRICEBOOK_TYPE_NAME_MAP[pricebookTypeName]
    const [createRoute] = useSlugExtractor([CREATE_ROUTE_MAP[pricebookType]])
    const { hasPermission } = useHasAccess()

    const tabsByPricebookType: Record<PricebookType, JSX.Element> = {
        service: <ServicesTabs />,
        part: <PartsAndMaterialsTabs />,
        other: <MiscellaneousTabs />,
        discount: <DiscountsTabs />,
        tax: <TaxRatesTabs />,
    }

    return (
        <Table.Provider
            activePhaseStorageKey={replaceSlugs(PRICEBOOK_LIST_CONTROLS_PHASE, {
                type: pricebookTypeName ?? "undefined",
            })}
            activeTabStorageKey={replaceSlugs(PRICEBOOK_LIST_CONTROLS_ACTIVE_TAB, {
                type: pricebookTypeName ?? "undefined",
            })}
            searchKeywordsStorageKey={replaceSlugs(PRICEBOOK_LIST_CONTROLS_KEYWORD_SEARCH, {
                type: pricebookTypeName ?? "undefined",
            })}
            orderingStorageKey={replaceSlugs(PRICEBOOK_LIST_CONTROLS_ORDERING, {
                type: pricebookTypeName ?? "undefined",
            })}
            listTitle={pricebookTypeName ?? ""}
            objectType="pricebook_item"
            objectCreateRoute={createRoute}
            objectIndexName="PriceBookItem"
            objectName="Pricebook Item"
            defaultActivePhase="active"
            objectTypeVariation={pricebookTypeName}
            isRowClickable={hasPermission("pricebook_edit_permission", PERMISSION_LEVEL.FULL)}
            isEmptyStateCreateButtonVisible={hasPermission("pricebook_create_permission", PERMISSION_LEVEL.FULL)}
        >
            <ViewBar.Root>
                <ViewBar.Start>
                    <ViewBar.Phases>
                        <Table.Phase phase="active" title="Active" />
                        <Table.Phase phase="inactive" title="Inactive" />
                    </ViewBar.Phases>
                    <ViewBar.VerticalDivider />
                    {tabsByPricebookType[pricebookType] ?? null}
                </ViewBar.Start>
                <ViewBar.End>
                    <Table.SearchInput />
                </ViewBar.End>
            </ViewBar.Root>
            <CardList CardComponent={PriceBookListCard} />
        </Table.Provider>
    )
}
